import { incYenOf, incOf } from '../lib/pricing';
export const courseOverview = {
  name: 'アドバンスコース',
  nameEn: 'ADVANCED COURSE',
  duration: '2ヶ月',
  days: '12日間',
  totalHours: '72時間',
  price: incYenOf('ac-advanced'),
  schedule: '5〜6月・11〜12月開校',
  classFormat: '土日開催・1日6時間（90分×4コマ）',
  capacity: '完全少人数制（定員6名）',
  target: '基礎知識がある方・スキルアップ希望者',
};

export const trustBadges = [
  {
    icon: 'ri-group-line',
    text: '定員6名の完全少人数制',
  },
  {
    icon: 'ri-hotel-bed-line',
    text: '本物のサービスを体験する特別実習つき',
  },
  {
    icon: 'ri-award-line',
    text: '修了で協会認定資格',
  },
  {
    icon: 'ri-checkbox-circle-line',
    text: 'エッセンシャルの全内容を含みます',
  },
];

export const targetAudienceItems = [
  {
    icon: 'ri-building-2-line',
    text: 'ホテル・レストラン等で働きながら専門性を高めたい方',
  },
  {
    icon: 'ri-stairs-line',
    text: 'エッセンシャルコース修了からステップアップする方',
  },
  {
    icon: 'ri-goblet-line',
    text: 'ワインや宴会運営の本格技能を求める方',
  },
  {
    icon: 'ri-global-line',
    text: '海外ゲスト対応力を身につけたい方',
  },
];

export const learningContents = [
  {
    id: 'service',
    title: '高度なサービス技術',
    titleEn: 'Advanced Service Techniques',
    description: 'エッセンシャルで学んだ基本所作を、シルバーサービスや複数ゲストへの同時サービスにまで高めます。ロールプレイングでは実際の晩餐会を想定した緊張感ある場面を体験し、どのような状況でも滞りないサービスを提供できる技術を磨きます。',
    icon: 'ri-vip-crown-line',
    imageSeq: 'advanced-service',
  },
  {
    id: 'wine',
    title: 'ワインとスピリッツの知識',
    titleEn: 'Wine & Spirits',
    description: '主要産地と品種の基礎知識から、保管と温度管理、抜栓からデキャンタージュ、美しい注ぎ方までの実技を体系的に学びます。テイスティング演習では、生産地やヴィンテージの違いを実際に感じ取り、ゲストへの的確な提案力を養います。',
    icon: 'ri-goblet-line',
    imageSeq: 'advanced-wine',
  },
  {
    id: 'event',
    title: 'イベント計画と管理',
    titleEn: 'Event Planning & Management',
    description: '晩餐会・パーティーの企画立案から、進行表の作成、当日の指揮まで一連の流れを実践的に学びます。座学でフレームワークを理解した後、実際に小規模なイベントを企画・運営するプロジェクト演習を行い、現場で通用するマネジメント力を身につけます。',
    icon: 'ri-calendar-event-line',
    imageSeq: 'advanced-event',
  },
  {
    id: 'table-advanced',
    title: 'テーブルセッティングの応用',
    titleEn: 'Advanced Table Setting',
    description: 'エッセンシャルで基礎を習得したテーブルセッティングを、フォーマルディナーのフルセッティングとテーマ別コーディネートへと発展させます。花や小物のあしらい、照明との調和まで考慮した空間演出の技術を習得し、あらゆる場面に対応できる応用力を養います。',
    icon: 'ri-restaurant-2-line',
    imageSeq: 'advanced-table',
  },
  {
    id: 'international',
    title: '国際的なマナーと文化理解',
    titleEn: 'International Etiquette',
    description: '国や宗教による食の禁忌や慣習、海外ゲストへの配慮の実例を学びます。模擬ディナーでは複数国籍のゲストを想定したシチュエーション演習を行い、文化的背景の違いを理解した上での適切なおもてなしを実践できる国際感覚を身につけます。',
    icon: 'ri-global-line',
    imageSeq: 'advanced-international',
  },
  {
    id: 'garment-care',
    title: '高級衣類のケア',
    titleEn: 'Luxury Garment Care',
    description: 'エッセンシャルで基礎を固めた衣類ケアを、スーツ・ドレス・革製品など素材別の高度な手入れへと発展させます。ウールやシルク、カシミヤ等のデリケートな素材に適した保管方法、トラブル発生時の応急処置まで、衣類資産を長く保護する専門技術を習得します。',
    icon: 'ri-t-shirt-air-line',
    imageSeq: 'advanced-garment',
  },
];

export const hotelTraining = {
  title: '本物のサービスを体験する特別実習',
  titleEn: 'Real Service Experience',
  description: '一流ホテルやレストランで提供される本格的なアフタヌーンティーやコース料理を、受講生がゲスト（お客様）として体験し、プロのサービスマンの所作・間合い・気配りを間近で観察して学びます。受け手の立場を知ることは、質の高いサービスを提供するうえで欠かせません。',
  details: [
    {
      icon: 'ri-hotel-bed-line',
      title: '体験先',
      text: '体験先は内容に応じてご案内します',
    },
    {
      icon: 'ri-time-line',
      title: '実施時間',
      text: '半日（約4時間）・コース期間内の1日に設定',
    },
    {
      icon: 'ri-check-double-line',
      title: '体験費用',
      text: '体験にかかる費用の詳細はお申込み時にご案内します',
    },
  ],
  note: '※体験先までの交通費のみご負担ください。',
};

export const dailySchedule = [
  { time: '10:00 – 11:30', title: '理論講義', description: '各回のテーマに沿った座学。ワインやイベント運営の専門知識を体系的に学びます。' },
  { time: '11:45 – 13:15', title: '実技演習', description: '講師のデモンストレーションの後、受講生お一人ずつ実践。ワインの抜栓やテーブルセッティングを繰り返し練習します。' },
  { time: '13:15 – 14:00', title: '昼食休憩', description: '' },
  { time: '14:00 – 15:30', title: 'ロールプレイング実習', description: '複数ゲストを想定した高度なシチュエーション演習。晩餐会やパーティーのサービスを実践形式で体験します。' },
  { time: '15:45 – 17:15', title: '実技＋講評', description: '午前の実技の応用演習と、その日の学びを講師とともに振り返るレビューセッション。個別フィードバックを行います。' },
];

export const certificationInfo = {
  title: '修了実技試験と認定資格',
  titleEn: 'Certification Exam',
  description: 'コース最終日に実施する修了実技試験（フォーマルディナーのセッティングとワインサービスの実演）に合格すると、以下の認定資格が授与されます。',
  qualification: '認定プロフェッショナルバトラー（Certified Professional Butler）',
  badge: '認定ピンバッジ',
  note: '※当資格は一般社団法人全日本執事協会が独自に認定する民間資格です。',
};

export const courseBenefits = [
  {
    icon: 'ri-book-open-line',
    title: '教科書セット（計10冊・E1〜E5+A1〜A5）',
    description: 'エッセンシャルのE群5冊に加え、家政管理・秘書業務・テーブルマナー・イベント企画・ライフスタイル管理のA群5冊を進呈。全日本執事協会監修。',
  },
  {
    icon: 'ri-goblet-line',
    title: 'ワインオープナーセット',
    description: 'ソムリエナイフとウェイターズコークスクリューをセットで進呈。実習および修了後もご使用いただけます。',
  },
  {
    icon: 'ri-tools-line',
    title: '基本的な執事道具セット',
    description: 'プロ仕様の基本ツール一式を進呈します。',
  },
  {
    icon: 'ri-t-shirt-2-line',
    title: 'オリジナルエプロン',
    description: '実習時に着用するアカデミー特製のエプロン。',
  },
  {
    icon: 'ri-hand-sanitizer-line',
    title: '白手袋（初日支給・実習で着用）',
    description: '高品質な白手袋。執事の象徴として、初日からサービス実習で着用します。',
  },
];

export const nextStep = {
  title: '編入優遇制度',
  descriptionEssential: 'アドバンスコースはエッセンシャルの内容を含むため、エッセンシャルコース修了者が本コースへ進む場合、重複する内容分の受講料80,000円が減額されます。',
  descriptionMaster: 'マスターコースはアドバンスの内容を含むため、本コース修了者がマスターコースへ進む場合、重複する内容分の受講料180,000円が減額されます。',
  essentialDiscount: '80,000',
  masterDiscount: '180,000',
};

export const admissionSteps = [
  {
    step: '01',
    title: '資料請求',
    titleEn: 'Brochure',
    description: 'まずは資料請求から。コースの詳細やアカデミーの理念をまとめた資料をお送りします。',
    icon: 'ri-file-text-line',
    href: '/brochure',
  },
  {
    step: '02',
    title: '個別相談（任意）',
    titleEn: 'Consultation',
    description: '経験豊富なスタッフが、あなたの目標やご経験に合わせた最適なコース選びをサポートします。',
    icon: 'ri-chat-3-line',
    href: '/consultation',
  },
  {
    step: '03',
    title: 'お申込み',
    titleEn: 'Apply',
    description: 'コースが決まりましたら、所定の申込フォームよりお手続きください。定員になり次第締切となります。',
    icon: 'ri-edit-line',
    href: '/apply',
  },
  {
    step: '04',
    title: '受講確定',
    titleEn: 'Confirmation',
    description: 'お申込み受付後、受講確定のご案内と事前準備資料をお送りします。開校日をお待ちください。',
    icon: 'ri-check-line',
    href: '#',
  },
];

export const relatedPages = [
  {
    title: 'エッセンシャルコース',
    description: '基礎から始める入門課程',
    href: '/courses/essential',
  },
  {
    title: 'マスターコース',
    description: '管理と危機対応まで修める最上級課程',
    href: '/courses/master',
  },
  {
    title: 'コース比較',
    description: '3コースの違いを一覧で確認',
    href: '/courses/comparison',
  },
  {
    title: '年間スケジュール',
    description: '開校時期と授業日程のご案内',
    href: '/schedule',
  },
  {
    title: '料金詳細',
    description: '受講料に含まれるものの内訳',
    href: '/pricing/details',
  },
  {
    title: 'カリキュラム',
    description: '学ぶ内容の全体像を確認',
    href: '/curriculum',
  },
];

export const faqItems = [
  {
    question: 'エッセンシャルコースを受けずに直接申し込めますか？',
    answer: 'はい、可能です。アドバンスコースはエッセンシャルの内容を含む課程のため、未経験の方も基礎から順に学べます。接客・サービスのご経験がある方はもちろん、経験不問でお申込みいただけます。なお、エッセンシャルコース修了者には重複内容分の編入優遇（受講料80,000円引き）もご用意しています。',
  },
  {
    question: '特別実習（サービス体験）の費用は別途かかりますか？',
    answer: '体験にかかる費用の詳細はお申込み時にご案内します。体験先までの交通費のみご負担ください。',
  },
  {
    question: '仕事と両立できますか？',
    answer: 'はい。授業は土日のみ・2ヶ月間（12日間）の設計ですので、お仕事を続けながらの受講を前提としています。',
  },
  {
    question: '支払い方法を教えてください。',
    answer: '銀行振込による一括払いのみとなります。分割払い・クレジットカードはご利用いただけません。お支払い期限は開校日の14日前です。',
  },
];